import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=98d0855c&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98d0855c')) {
      api.createRecord('98d0855c', component.options)
    } else {
      api.reload('98d0855c', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=98d0855c&", function () {
      api.rerender('98d0855c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2vug0To52u0oP/JS/imageCarousel.vue"
export default component.exports